import React from 'react';
import { Backdrop, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 1301,
  },
  circularProgress: {
    color: "#E7C951",
  }
}));

const LoadingOverlay = ({open}: {open: boolean}) => {
  const classes = useStyles();
  return (
    <Backdrop className={classes.backdrop} open={open}>
      <CircularProgress size="4rem" className={classes.circularProgress}/>
    </Backdrop>
  );
};

export default LoadingOverlay;